module.exports = __webpack_public_path__ + "img/Q5.01269b6e.jpg";